export default "images/aboutIcon.png";